import type { WebsiteHeaderPhotoSchema_PhotoDuoRight } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_DUO_RIGHT_DEFAULT: WebsiteHeaderPhotoSchema_PhotoDuoRight = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoRight-v1_1_1.json',
  presentationLayout: 'photoDuoRight',
  photos: [],
};
